import { render } from "./EditRetailer.vue?vue&type=template&id=000260f9&scoped=true"
import script from "../js/edit-retailer.js?vue&type=script&lang=js"
export * from "../js/edit-retailer.js?vue&type=script&lang=js"

import "./EditRetailer.vue?vue&type=style&index=0&id=000260f9&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000260f9"]])

export default __exports__